import React from "react";
import GenericModal from "@ui-components/Modal/GenericModal";
import { InstanceData } from "../StatusData";
import GenericButton from "@ui-components/Button/GenericButton";
import { ReactComponent as IconCopy } from "../../../../shared/assets/Icons/CopyIcon.svg";
import GenericTooltip from "@ui-components/Tooltip/GenericTooltip";

interface InstanceDetailsModalProps {
	isOpen: boolean;
	onClose: () => void;
	instanceData: InstanceData | null;
}

const InstanceDetailsModal: React.FC<InstanceDetailsModalProps> = ({
	isOpen,
	onClose,
	instanceData,
}) => {
	if (!instanceData) return null;

	const metadata = instanceData.metadata || {};

	return (
		<GenericModal
			isOpen={isOpen}
			onClose={onClose}
			title={`${instanceData.name} Details`}
			size="md"
		>
			<div className="space-y-4">
				<div className="space-y-4">
					<div className="flex items-start justify-between gap-4">
						<div className="flex-1 min-w-0">
							<h3 className="text-semantic-text-secondary font-bold">
								Instance Id:
							</h3>
							<p className="text-semantic-text-secondary truncate">
								{metadata.instance_id}
							</p>
						</div>
						<GenericButton
							label=""
							variant="secondary"
							onClick={() =>
								navigator.clipboard.writeText(metadata.instance_id || "")
							}
							icon={
								<IconCopy className="w-4 h-4 text-semantic-text-secondary" />
							}
						/>
					</div>

					<div className="flex items-start justify-between gap-4">
						<div className="flex-1 min-w-0">
							<h3 className="text-semantic-text-secondary font-bold">
								Instance Type:
							</h3>
							<p className="text-semantic-text-secondary truncate">
								{metadata.instance_type}
							</p>
						</div>
						<GenericButton
							label=""
							variant="secondary"
							onClick={() =>
								navigator.clipboard.writeText(metadata.instance_type || "")
							}
							icon={
								<IconCopy className="w-4 h-4 text-semantic-text-secondary" />
							}
						/>
					</div>

					<div className="flex items-start justify-between gap-4">
						<div className="flex-1 min-w-0">
							<h3 className="text-semantic-text-secondary font-bold">
								Image Id:
							</h3>
							<p className="text-semantic-text-secondary truncate">
								{instanceData.version}
							</p>
						</div>
						{instanceData.version && instanceData.version !== "?" ? (
							<GenericButton
								label=""
								variant="secondary"
								onClick={() =>
									navigator.clipboard.writeText(instanceData.version || "")
								}
								icon={
									<IconCopy className="w-4 h-4 text-semantic-text-secondary" />
								}
							/>
						) : (
							<GenericTooltip
								text="Contact CTX support to know what to do next"
								position="top"
							>
								<GenericButton
									label=""
									variant="secondary"
									disabled
									icon={
										<IconCopy className="w-4 h-4 text-semantic-text-secondary" />
									}
								/>
							</GenericTooltip>
						)}
					</div>

					<div className="flex items-start justify-between gap-4">
						<div className="flex-1 min-w-0">
							<h3 className="text-semantic-text-secondary font-bold">
								Cloud Hostname:
							</h3>
							<p className="text-semantic-text-secondary truncate">
								{metadata.cloud_hostname}
							</p>
						</div>
						<GenericButton
							label=""
							variant="secondary"
							onClick={() =>
								navigator.clipboard.writeText(metadata.cloud_hostname || "")
							}
							icon={
								<IconCopy className="w-4 h-4 text-semantic-text-secondary" />
							}
						/>
					</div>

					<div className="flex items-start justify-between gap-4">
						<div className="flex-1 min-w-0">
							<h3 className="text-semantic-text-secondary font-bold">
								Local Hostname:
							</h3>
							<p className="text-semantic-text-secondary truncate">
								{metadata.local_hostname}
							</p>
						</div>
						<GenericButton
							label=""
							variant="secondary"
							onClick={() =>
								navigator.clipboard.writeText(metadata.local_hostname || "")
							}
							icon={
								<IconCopy className="w-4 h-4 text-semantic-text-secondary" />
							}
						/>
					</div>

					<div className="flex items-start justify-between gap-4">
						<div className="flex-1 min-w-0">
							<h3 className="text-semantic-text-secondary font-bold">
								Availability Zone:
							</h3>
							<p className="text-semantic-text-secondary truncate">
								{metadata.availability_zone}
							</p>
						</div>
						<GenericButton
							label=""
							variant="secondary"
							onClick={() =>
								navigator.clipboard.writeText(metadata.availability_zone || "")
							}
							icon={
								<IconCopy className="w-4 h-4 text-semantic-text-secondary" />
							}
						/>
					</div>

					<div className="flex items-start justify-between gap-4">
						<div className="flex-1 min-w-0">
							<h3 className="text-semantic-text-secondary font-bold">
								Security Groups:
							</h3>
							<p className="text-semantic-text-secondary truncate">
								{metadata.security_groups}
							</p>
						</div>
						<GenericButton
							label=""
							variant="secondary"
							onClick={() =>
								navigator.clipboard.writeText(metadata.security_groups || "")
							}
							icon={
								<IconCopy className="w-4 h-4 text-semantic-text-secondary" />
							}
						/>
					</div>
				</div>
			</div>
		</GenericModal>
	);
};

export default InstanceDetailsModal;
